import { AppConfig } from '../types/app';

// Remember-me feature gate (SSM /simplified-sign-in/enableRememberLogin).
export const isRememberLoginEnabled = (
  config?: Pick<AppConfig, 'enableRememberLogin'>
): boolean => String(config?.enableRememberLogin) === 'true';
